import React from 'react';
import styled from 'styled-components';
import useSite from 'gatsby-theme-core/src/hooks/use-site';
import Wrapper from 'gatsby-theme-menus/src/components/nav/cover-nav/wrapper';
import Stars from 'gatsby-theme-rating/src/components/stars';
import TotalMaximumScore, { TotalScore, MaximumScore } from 'gatsby-theme-rating/src/components/total-maximum-score';
import useRating from 'gatsby-theme-rating/src/hooks/use-rating';

const Rating = ({ className }) => {
  const { id: siteId } = useSite();
  const rating = useRating({
    siteId,
  });

  if (!rating) {
    return null;
  }

  return (
    <Wrapper>
      <div className={className}>
        <TotalMaximumScore
          siteId={siteId}
          css={`
            margin-right: .5rem;
            ${TotalScore} {
              font-size: 1.25rem;
            }
            ${MaximumScore} {
              font-size: 1rem;
            }
          `}
        />
        <Stars siteId={siteId} />
      </div>
    </Wrapper>
  );
};

export default styled(Rating)`
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
`;
